module.exports = __webpack_public_path__ + "img/col-bgimage-6.0c302419.png";